export abstract class NumerosUtils {
  public static getNumber(numero: number): string {
    let res: string = '';
    if (numero < 10) {
      res = '00' + numero;
    } else if (numero >= 10) {
      res = '0' + numero;
    } else {
      res = '' + numero;
    }

    return res;
  }

  public static getNumberTwo(numero: number): string {
    let res: string = '';
    if (numero < 10) {
      res = '0' + numero;
    } else {
      res = '' + numero;
    }

    return res;
  }

  public static addZero(number: number): string {
    let strNumber = '';
    if (number < 100) strNumber = '0';
    if (number < 10) strNumber += '0';
    strNumber += number;
    return strNumber;
  }
}
